<template>
  <template v-if="legalDisclaimer">
    <BaseSeparator v-if="separator" />
    <div v-bind="$attrs">
      {{ legalDisclaimer }}
    </div>
  </template>
</template>

<script>
import { BaseSeparator } from "shared/components/base";

export default {
  name: "MentionLegalDisclaimer",
  components: {
    BaseSeparator,
  },
  props: {
    mention: {
      type: Object,
      required: true,
    },
    separator: {
      type: Boolean,
    },
  },
  computed: {
    legalDisclaimer() {
      if (this.mention.source?.name === "The New York Times") {
        const date = new Date();

        return `©${date.getFullYear()} The New York Times. All rights reserved. Redistribution prohibited except if under license.`;
      }

      return "";
    },
  },
};
</script>
